import QRCode from 'react-qr-code';
import { Button } from '@/components/ui/button';
import { getBrandMeta } from '@/brandMeta';
import { APP_ORIGIN, SUBSIDIARY_CODE } from '@/config';

const brand = getBrandMeta(SUBSIDIARY_CODE);

/** A phone goes straight to its own store; a computer gets both stores and a code to scan with the phone. */
export function GetTheApp() {
  const ua = navigator.userAgent;
  // iPadOS Safari reports itself as a Mac; a touchscreen gives it away
  const ios = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  const android = /Android/.test(ua);

  return (
    <div className="space-y-4 text-center">
      <p className="text-muted-foreground">
        Take the campaign with you in the {brand.appName} app. Sign in with the same email and password.
      </p>
      <div className="flex flex-wrap justify-center gap-2">
        {!android && (
          <Button asChild size="lg">
            <a href={brand.appStoreUrl} target="_blank" rel="noopener noreferrer">Download on the App Store</a>
          </Button>
        )}
        {!ios && (
          <Button asChild size="lg" variant={android ? 'default' : 'outline'}>
            <a href={brand.playStoreUrl} target="_blank" rel="noopener noreferrer">Get it on Google Play</a>
          </Button>
        )}
      </div>
      {!ios && !android && (
        // Hidden at phone widths: nothing to scan it with from the phone itself
        <div className="hidden sm:flex flex-col items-center gap-2 pt-2">
          <QRCode
            value={`${APP_ORIGIN}/get-app`}
            size={96}
            role="img"
            aria-label="Scan with your phone's camera to get the app"
          />
          <p className="text-xs text-muted-foreground">Scan with your phone's camera</p>
        </div>
      )}
    </div>
  );
}
